module.exports = __webpack_public_path__ + "static/media/no-result.56a78516.svg";